export default [
  {
    url: "/home",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
  },
  {
    url: '/documents/store',
    name: "Store Documents",
    slug: 'storeDocument',
    icon: "LogInIcon",
    i18n: "storeDocument",
  },
  {
    url: null,
    name: "Your Documents",
    tagColor: "warning",
    icon: "FolderIcon",
    i18n: "Store",
    submenu: [
      {
        url: '/documents',
        name: 'All',
        slug: "All",
        i18n: "All",
      },
      {
        url: '/documents_sent_to_storage',
        name: 'Sent to Storage',
        slug: 'Sent to Storage',
        i18n: 'Sent to Storage',
      },
      {
        url: '/documents_in_storage',
        name: 'In Storage',
        slug: "In Storage",
        i18n: "In Storage",
      },
      {
        url: '/documents_requested_from_storage',
        name: 'Req. from Storage',
        slug: 'Req. from Storage',
        i18n: 'Req. from Storage',
      },
      {
        url: '/documents_sent_from_storage',
        name: 'Sent back to Us',
        slug: 'Sent back to Us',
        i18n: 'Sent back to Us',
      }
    ]
  },
]
